<template>
  <div class="lishihuice-page">

    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>

    <div class="header">
      <div class="logo">
        <div class="icon">
          <img src="@/assets/lishihuice/icon2.png">
        </div>
        <h1>历史回测结果</h1>
      </div>
      <!-- <p class="subtitle">基于 2016-2025 年历史数据结果</p> -->
      <p class="subtitle">基于历史数据结果</p>
    </div>

    <div class="content">
      <div class="main-charts">
        <div class="chart-container">
          <div class="chart-header">
            <h3><i class="el-icon-line-chart"></i> 净值走势曲线</h3>
          </div>
          <div ref="netValueChart" class="chart"></div>
        </div>

        <div class="chart-container">
          <div class="chart-header">
            <h3><i class="el-icon-data-line"></i> 回测走势（水下时间段）</h3>
          </div>
          <div ref="drawdownChart" class="chart"></div>
        </div>
      </div>

      <div class="right-section">
        <div class="backtest-dashboard">
          <h3 class="dashboard-title">回测看板</h3>

          <div class="dashboard-item">
            <div class="item-label">年化收益</div>
            <div class="item-value green">{{ (metrics.annualizedReturn * 100).toFixed(2) }}%</div>
          </div>

          <div class="dashboard-item">
            <div class="item-label">夏普比率</div>
            <div class="item-value blue">{{ metrics.sharpeRatio }}</div>
          </div>

          <div class="dashboard-item">
            <div class="item-label">最大回撤</div>
            <div class="item-value pink">{{ (metrics.maxDrawdown * 100).toFixed(2) }}%</div>
          </div>

          <div class="dashboard-item">
            <div class="item-label">累计收益率</div>
            <div class="item-value green">{{ (metrics.cumulativeReturn * 100).toFixed(2) }}%</div>
          </div>

          <div class="dashboard-item">
            <div class="item-label">年化波动率</div>
            <div class="item-value blue">{{ (metrics.annualizedVolatility * 100).toFixed(2) }}%</div>
          </div>

          <div class="dashboard-item">
            <div class="item-label">卡玛比率</div>
            <div class="item-value pink">{{ metrics.calmarRatio }}</div>
          </div>

          <div>
            <div>
              <span style="color:#64748b;">最后一日组合价值：</span>
              <span style="color:red;font-weight:bold;">{{ finalPortfolioValue }}</span>
            </div>
            <div style="margin-top: 10px;">
              <span style="color:#64748b;">是否满足客户预期：</span>
              <span style="color: green;font-size: 18px;font-weight:bold;" v-if="customerEvaluation.meetsExpectation">
                <!-- <i class="el-icon-check" ></i> -->
                是
              </span>
              <span style="color: red;font-size: 18px;font-weight:bold;" v-else>
                <!-- <i class="el-icon-close" style="color: red;font-size: 24px;font-weight:bold;"></i> -->
                否
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="footer">
      <button class="reset-btn common-btn" id="btn-reset-weight-backtest" @click="handleReset">
        重新调整权重 <i class="el-icon-refresh"></i>
      </button>
      <button class="common-btn" id="btn-dimension-analysis" @click="handleDimensionAnalysis">查看维度分析与建议</button>
      <button class="stress-test-btn common-btn" id="btn-stress-test" @click="handleStressTest">
        进入压力测试 <i class="el-icon-right"></i>
      </button>
    </div>
    <div class="footer-bottom">
      <span @click="handleAdjust">调整回测参数</span>
    </div>

    <el-dialog :visible.sync="DimensionAnalysis" width="95%" :close-on-click-modal="false"
               custom-class="dimension-dialog" @closed="handleDimensionDialogClosed">
      <div slot="title" class="dialog-title-bar">
        <span class="dialog-title-icon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 20V10" />
            <path d="M18 20V4" />
            <path d="M6 20v-4" />
          </svg>
        </span>
        <span>维度分析与建议</span>
      </div>
      <div class="dialog-content">
        <div class="conten-section">
          <div class="dimension-analysis">
            <el-table :data="customerEvaluation.dimensions" style="width: 100%"
                      :header-cell-style="{ background: '#f8fafc', color: '#475569', fontWeight: '600', fontSize: '13px' }"
                      :cell-style="{ fontSize: '13px' }">
              <el-table-column prop="displayName" label="指标" min-width="40" />
              <el-table-column prop="target" label="目标值" min-width="40" align="center" />
              <el-table-column prop="actual" label="实际值" min-width="40" align="center" />
              <el-table-column prop="passed" label="是否完成" min-width="50" align="center">
                <template slot-scope="scope">
                  <span :class="['pass-badge', scope.row.passed ? 'pass' : 'fail']">
                    {{ scope.row.passed ? '已完成' : '未完成' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="gap" label="差值" min-width="40" align="center" />
              <!-- <el-table-column prop="insight" label="解析" min-width="140" show-overflow-tooltip /> -->
              <el-table-column prop="insight" label="解析" min-width="140" />
            </el-table>
          </div>
          <div class="jianyi">
            <h3 class="section-title">优化建议</h3>
            <div class="suggestions-list">
              <div class="suggestion-item" v-for="(item, idx) in customerEvaluation.suggestions" :key="idx">
                <span class="suggestion-num">{{ idx + 1 }}</span>
                <span class="suggestion-text">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'LishihuicePage',
  data () {
    return {
      metrics: {},//回测看板数据
      netValueChart: null,
      drawdownChart: null,
      // 示例数据
      netValueData: {
        dates: [],
        equity: [],
        benchmark: []
        // dates: ['2023-01', '2023-03', '2023-06', '2023-09', '2023-12', '2024-03', '2024-06', '2024-09', '2024-12', '2025-03'],
        // equity: [1.0, 1.02, 1.04, 1.06, 1.08, 1.10, 1.12, 1.14, 1.15, 1.16],
        // benchmark: [1.0, 1.01, 1.03, 1.05, 1.07, 1.09, 1.11, 1.12, 1.13, 1.14]
      },
      drawdownData: {
        dates: [],
        values: []
        // dates: ['2023-01', '2023-03', '2023-06', '2023-09', '2023-12', '2024-03', '2024-06', '2024-09', '2024-12', '2025-03'],
        // values: [0, -1.5, -0.5, -1.0, -0.5, -2.0, -1.0, -2.5, -1.5, -0.5]
      },
      DimensionAnalysis: false,//维度分析与建议
      finalPortfolioValue: 0,//最后一日组合价值
      customerEvaluation: {
        dimensions: [], //维度
        meetsExpectation: false,//是否满足客户预期  false 不满足  true 满足
        suggestions: []//建议
      }
    }
  },
  created () {
    this.runAudio()
  },
  mounted () {
    window.addEventListener('storage', this.handleStorageChange)
    let backtestResult = JSON.parse(localStorage.getItem('backtestResult'))
    this.metrics = backtestResult.metrics
    let benchmarkCurve = backtestResult.benchmarkCurve || []
    let drawdownCurve = backtestResult.drawdownCurve || []
    let equityCurve = backtestResult.equityCurve || []
    drawdownCurve.forEach(item => {
      this.drawdownData.values.push(item.drawdown)
      this.drawdownData.dates.push(item.tradingDate)
    })
    if (benchmarkCurve.length > 0) {
      // alert("有基准指数")
      benchmarkCurve.forEach(item => {
        equityCurve.forEach(item2 => {
          if (item2.tradingDate === item.tradingDate) {
            this.netValueData.equity.push(item2.portfolioValue)
            this.netValueData.benchmark.push(item.benchmarkValue)
            this.netValueData.dates.push(item.tradingDate)
          }
        })
      })
    } else {
      equityCurve.forEach(item => {
        this.netValueData.equity.push(null)
        this.netValueData.benchmark.push(item.periodReturn)
        this.netValueData.dates.push(item.tradingDate)
      })
    }
    this.initCharts()
    window.addEventListener('resize', this.resizeCharts)

    let customerEvaluation = backtestResult.customerEvaluation || {}
    // console.log("customerEvaluation>>>", customerEvaluation);
    this.customerEvaluation = customerEvaluation
    this.finalPortfolioValue = backtestResult.finalPortfolioValue || 0
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('resize', this.resizeCharts)
    if (this.netValueChart) {
      this.netValueChart.dispose()
    }
    if (this.drawdownChart) {
      this.drawdownChart.dispose()
    }
  },
  methods: {
    // 播放音频
    runAudio () {
      this.playOnceAudio('/历史回测成功，可查看维度分析，进行压力测试.mp3')
    },
    handleDimensionAnalysis () {
      this.DimensionAnalysis = true
      // 同步副屏：写入 localStorage 触发 storage 事件
      localStorage.setItem('lishihuice_dimension_dialog', JSON.stringify({ open: true, timestamp: Date.now() }))
    },
    handleDimensionDialogClosed () {
      // 通知副屏关闭弹窗
      localStorage.setItem('lishihuice_dimension_dialog', JSON.stringify({ closed: true, timestamp: Date.now() }))
    },
    handleStorageChange (event) {
      if (event.key === 'lishihuice_dimension_dialog' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          if (data && data.closed) {
            this.DimensionAnalysis = false
          } else if (data && data.open) {
            this.DimensionAnalysis = true
          }
        } catch (e) { /* ignore */ }
      }
    },
    initCharts () {
      this.initNetValueChart()
      this.initDrawdownChart()
    },
    initNetValueChart () {
      this.netValueChart = echarts.init(this.$refs.netValueChart)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['本策略', '基准指数'],
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.netValueData.dates
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '本策略',
            type: 'line',
            data: this.netValueData.equity,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#3b82f6',
              width: 2
            },
            itemStyle: {
              color: '#3b82f6'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(59, 130, 246, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(59, 130, 246, 0.1)'
                }
              ])
            }
          },
          {
            name: '基准指数',
            type: 'line',
            data: this.netValueData.benchmark,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#f97316',
              width: 2
            },
            itemStyle: {
              color: '#f97316'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(249, 115, 22, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(249, 115, 22, 0.1)'
                }
              ])
            }
          }
        ]
      }

      this.netValueChart.setOption(option)
    },
    initDrawdownChart () {
      this.drawdownChart = echarts.init(this.$refs.drawdownChart)

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.drawdownData.dates
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '回撤',
            type: 'line',
            stack: 'Total',
            data: this.drawdownData.values,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#ef4444',
              width: 2
            },
            itemStyle: {
              color: '#ef4444'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(239, 68, 68, 0.3)'
                },
                {
                  offset: 1,
                  color: 'rgba(239, 68, 68, 0.1)'
                }
              ])
            }
          }
        ]
      }

      this.drawdownChart.setOption(option)
    },
    resizeCharts () {
      if (this.netValueChart) {
        this.netValueChart.resize()
      }
      if (this.drawdownChart) {
        this.drawdownChart.resize()
      }
    },
    handleReset () {
      // 重新调权配置的逻辑
      console.log('重新调权配置')
      this.$router.push({ name: 'Tiaozhengzichanbili' })
    },
    handleStressTest () {
      // 进入压力测试的逻辑
      console.log('进入压力测试')
      this.$router.push({ name: 'Yaliceshi' })
    },
    handleAdjust () {
      // 调整回测参数的逻辑
      console.log('调整回测参数')
      this.$router.push({ name: 'Lishihuice' })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
  padding: 0 !important;
}

.lishihuice-page {
  min-height: 100vh;
  // background: linear-gradient(to right, #eff6ff, #f9fbff);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px 40px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 16px;
  text-align: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.logo i {
  font-size: 32px;
  color: #3b82f6;
}

.logo h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #486dff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  text-align: left;
}

.content {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}

.main-charts {
  flex: 3;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.chart-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.chart-header {
  margin-bottom: 20px;
}

.chart-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-header i {
  font-size: 18px;
}

.chart {
  width: 100%;
  height: 240px;
}

.conten-section {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.right-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.backtest-dashboard {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.dashboard-title {
  font-size: 16px;
  font-weight: 600;
  color: #3b82f6;
  margin: 0 0 20px 0;
}

.dashboard-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.dashboard-item:last-child {
  margin-bottom: 0;
}

.item-label {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
  width: 120px;
}

.item-value {
  width: 100%;
  font-size: 24px;
  font-weight: 700;
  padding: 12px;
  border-radius: 8px;
  display: inline-block;
}

.item-value.green {
  background: #d1fae5;
  color: #10b981;
}

.item-value.blue {
  background: #dbeafe;
  color: #3b82f6;
}

.item-value.pink {
  background: #fee2e2;
  color: #ef4444;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
}

.reset-btn {
  width: 300px;
  font-size: 18px;
  background: #e2e8f0;
  color: #64748b;
}

.reset-btn:hover {
  background: #cbd5e1;
}

.stress-test-btn {
  width: 300px;
  font-size: 18px;
}

.stress-test-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.adjust-btn {
  padding: 12px 24px;
  background: white;
  border: 2px solid #3b82f6;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #3b82f6;
  cursor: pointer;
  transition: all 0.3s ease;
}

.adjust-btn:hover {
  background: #3b82f6;
  color: white;
}

.footer-bottom {
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #155dfc;
    cursor: pointer;
  }
}

/* 横屏适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .lishihuice-page {
    padding: 20px 40px;
  }

  .header {
    margin-bottom: 8px;
  }

  .logo h1 {
    font-size: 32px;
  }

  .logo i {
    font-size: 36px;
  }

  .content {
    margin-bottom: 12px;
  }

  .main-charts {
    gap: 12px;
  }

  .chart-container {
    padding: 16px;
  }

  .chart {
    height: 200px;
  }

  .backtest-dashboard {
    padding: 16px;
  }

  .reset-btn,
  .stress-test-btn,
  .adjust-btn {
    padding: 14px 28px;
    font-size: 16px;
  }

  .footer {
    margin-top: 12px;
  }

  .footer-bottom {
    margin-top: 8px;

    span {
      font-size: 12px;
    }
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .lishihuice-page {
    padding: 20px 16px;
    min-height: 100vh;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .header {
    margin-bottom: 0;
    text-align: center;
    // padding-top: 10px;
  }

  .logo {
    // flex-direction: column;
    gap: 8px;
    justify-content: center;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    // color: #1e293b;
    letter-spacing: 0.5px;
    // background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // background-clip: text;
    margin: 0;
  }

  .logo i {
    font-size: 20px;
    color: #6366f1;
  }

  .content {
    flex-direction: column;
    gap: 16px;
    // flex: 1;
    display: flex;
  }

  .main-charts {
    flex-direction: column;
    gap: 16px;
  }

  .chart-container {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .chart-title {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 12px;
  }

  .chart {
    height: 200px;
  }

  .right-section {
    gap: 16px;
  }

  .backtest-dashboard {
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid rgba(99, 102, 241, 0.08);
  }

  .dashboard-title {
    font-size: 14px;
    font-weight: 600;
    // color: #6366f1;
    margin-bottom: 16px;
  }

  .dashboard-item {
    margin-bottom: 14px;
  }

  .item-label {
    font-size: 12px;
    color: #64748b;
    width: 100px;
  }

  .item-value {
    font-size: 20px;
    font-weight: 700;
    padding: 10px;
    border-radius: 8px;
  }

  .footer {
    display: none;
    flex-direction: column;
    gap: 12px;
    margin-top: 0;
    padding-top: 0;
  }

  .reset-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border: 1px solid #e2e8f0;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .reset-btn:hover {
    background: #cbd5e1;
  }

  .stress-test-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .stress-test-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .stress-test-btn:hover::before {
    left: 100%;
  }

  .stress-test-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }

  .adjust-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: white;
    border: 2px solid #6366f1;
    color: #6366f1;
    transition: all 0.2s ease;
  }

  .adjust-btn:hover {
    background: #6366f1;
    color: white;
  }

  .footer-bottom {
    display: none;
    margin-top: 8px;

    span {
      font-size: 12px;
      color: #6366f1;
    }
  }

  .dimension-dialog {
    width: 92vw !important;
    max-width: 380px !important;
    border-radius: 12px;
  }

  .dimension-dialog .el-dialog__header {
    padding: 12px 14px 10px;
  }

  .dimension-dialog .el-dialog__body {
    max-height: 65vh;
  }

  .dimension-dialog .dialog-content {
    padding: 10px 12px 14px;
  }

  .dimension-dialog .conten-section {
    gap: 14px;
  }

  .dimension-dialog .dimension-analysis {
    overflow-x: auto;
  }

  .dimension-dialog .el-table {
    min-width: 520px;
  }

  .dimension-dialog .el-table th,
  .dimension-dialog .el-table td {
    font-size: 11px;
    padding: 6px 2px;
  }

  .dimension-dialog .section-title {
    font-size: 15px;
    margin-bottom: 8px;
  }

  .dimension-dialog .suggestion-item {
    font-size: 12px;
    padding: 8px 0;
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .lishihuice-page {
    padding: 16px;
  }

  .header {
    margin-bottom: 16px;
  }

  .logo h1 {
    font-size: 20px;
  }

  .logo i {
    font-size: 24px;
  }

  .subtitle {
    font-size: 12px;
  }

  .chart-container {
    padding: 16px;
    border-radius: 12px;
  }

  .chart {
    height: 200px;
  }

  .backtest-dashboard {
    padding: 16px;
    border-radius: 12px;
  }

  .item-value {
    font-size: 20px;
    padding: 10px;
  }

  .reset-btn,
  .stress-test-btn,
  .adjust-btn {
    padding: 10px 20px;
    font-size: 14px;
  }
}

/* ============================================
   维度分析与建议弹窗样式
   ============================================ */
.dialog-title-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.dialog-title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
}

.dimension-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.dimension-dialog .el-dialog__header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.dimension-dialog .el-dialog__body {
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
}

.dimension-dialog .dialog-content {
  padding: 20px 24px 24px;
}

.dimension-dialog .conten-section {
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  gap: 20px;
}

.dimension-dialog .el-table {
  border-radius: 10px;
  overflow: hidden;
}

.dimension-dialog .el-table th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 2px solid #e2e8f0;
}

.dimension-dialog .el-table td {
  padding: 10px 0;
  color: #334155;
}

.dimension-dialog .el-table__row:hover>td {
  background: #f8faff;
}

/* 完成/未完成 徽标 */
.pass-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
}

.pass-badge.pass {
  background: #ecfdf5;
  color: #059669;
}

.pass-badge.fail {
  background: #fff1f2;
  color: #e11d48;
}

/* 建议列表 */
.jianyi {
  background: #f8faff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #eef2ff;
}

.jianyi .section-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 14px 0;
}

.suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.suggestion-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: white;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.suggestion-item:hover {
  border-color: #c7d2fe;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.08);
}

.suggestion-num {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.suggestion-text {
  flex: 1;
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
}

/* 弹窗内滚动条 */
.dimension-dialog .el-dialog__body::-webkit-scrollbar {
  width: 5px;
}

.dimension-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.dimension-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: transparent;
}
</style>